<div class="player-deck">
  <div class="player">
    <div class="avatar-container"><tg-avatar [uid]="player.uid"></tg-avatar></div>
    <div class="name">{{ player.name }}</div>
  </div>
  <div class="cards">
    <app-card
      *ngFor="let card of player.meansCards"
      [card]="card"
      [active]="!disableSelectionDisplay && selectedMeans === card.name"
      [means]="true"
      (click)="!disableSelection && meansClick(card.name)"
    ></app-card>
  </div>
  <div class="cards">
    <app-card
      *ngFor="let card of player.clueCards"
      [card]="card"
      [active]="!disableSelectionDisplay && selectedClue === card.name"
      [means]="false"
      (click)="!disableSelection && clueClick(card.name)"
    ></app-card>
  </div>
</div>
